import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { AreaAtuacaoService } from '@/core/api/sicom-api/servicos/pessoa-fisica/area-atuacao/area-atuacao.service';
import { ServicoAnexoService } from '@/core/api/sicom-api/servicos/shared/servico-anexo.service';
import type { AreaAtuacaoRequest, AreaAtuacaoResponse } from '@/core/api/sicom-api/servicos/pessoa-fisica/area-atuacao/area-atuacao.model';

@Injectable({ providedIn: 'root' })
export class AreaAtuacaoServicosService {
    constructor(
        private api: AreaAtuacaoService,
        private servicoAnexo: ServicoAnexoService
    ) {}

    consultar(params: AreaAtuacaoRequest, context?: HttpContext): Observable<AreaAtuacaoResponse> {
        if (!params?.numeroProtocolo || !params?.anoProtocolo || !params?.ufCrm) {
            return throwError(() => new Error('Parâmetros inválidos: numeroProtocolo, anoProtocolo e ufCrm são obrigatórios.'));
        }

        return this.api.consultar(params, context);
    }

    visualizarAnexo(idAnexo: string, context?: HttpContext): Observable<Blob> {
        const id = idAnexo?.trim();
        if (!id) {
            return throwError(() => new Error('Id do anexo não informado.'));
        }

        return this.servicoAnexo.visualizarAnexo(id, context);
    }
}
